import { ReportsAction } from "store/actions";
import { reducer } from "..";
import { IAction } from "store/actions/i-action";
import { QuickViewQueries } from "store/types";
import { defaultQuickViewQueries } from "constants/reports";

reducer.createHandler(
  ReportsAction.SetQuickViewQueries,
  (state, { payload }: IAction<{ queries: Partial<QuickViewQueries>; replace?: boolean }>) => {
    const { queries, replace } = payload;

    return {
      ...state,
      reports: {
        ...state.reports,
        quickViewQueries: {
          ...(replace ? defaultQuickViewQueries : state.reports.quickViewQueries),
          ...queries,
          ...(queries.columns && replace // Handle columns
            ? { columns: { ...defaultQuickViewQueries.columns, ...queries.columns } }
            : { columns: { ...state.reports.quickViewQueries.columns, ...queries.columns } })
        }
      }
    };
  }
);
